import { Component, Input, Output, EventEmitter, TemplateRef, ContentChild, ViewChild } from "@angular/core";
import { Sizes } from "../types/tab.types";

@Component({
  selector: "ds-tab",
  templateUrl: "./ds-tab.component.html",
  styleUrls: ["./ds-tab.component.scss"],
})
export class DsTabComponent {
  @Input() label!: string;
  @Input() disabled: boolean = false;
  @Input() counter?: number | string;
  @Output() select = new EventEmitter<void>();

  @ViewChild("templateButton", { static: true }) templateButton!: TemplateRef<any>;
  @ViewChild("content", { static: true }) content!: TemplateRef<any>;

  size: Sizes = "md";
  active: boolean;
  constructor() {}
}
